import Marquee from "react-fast-marquee";
import { useLanguage } from "../../lib/i18n";

export const MarqueeStrip = () => {
  const { t } = useLanguage();
  const phrases = t("marquee");
  return (
    <section className="relative py-16 md:py-24 border-y border-white/[0.06] overflow-hidden" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} autoFill>
        {phrases.map((p, i) => (
          <span key={i} className="flex items-center">
            <span className="font-head font-semibold text-6xl md:text-8xl lg:text-9xl tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.18)] px-8">{p}</span>
            <span className="text-blue-500 text-5xl md:text-7xl">—</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
